import { Injectable } from '@angular/core';
import { ClientNote, ClientNoteType } from 'src/app/clients-module/models/clientLocation';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  clientNoteTypes : ClientNoteType[] = [
    new ClientNoteType(1,"Credentialing","changes"),
    new ClientNoteType(2,"Account Setup", "setup"),
    new ClientNoteType(3,"Check-in", "checkin"),
    new ClientNoteType(4,"Past Due","pastdue"),
    new ClientNoteType(5,"Payment", "payment"),
    new ClientNoteType(6,"Permanent Disable", "disabled"),
    new ClientNoteType(7,"Question / Problem", "preguntas"),
    new ClientNoteType(8,"Rerun","rerun"),
    new ClientNoteType(9,"Refund", "refund"),
    new ClientNoteType(10, "Review / Audit", "review")
  ]

  public notes : ClientNote[];

  constructor(private http : HttpClient, private auth : AuthService, private toast : ToastrService) { }

  SaveNote(note : ClientNote, parentCollection : ClientNote[]){
    let urlPath : string = note.locationId > 0 ? '/api/notes/loc/save' : '/api/notes/save';
    this.http.post(environment.baseURl + urlPath ,note).subscribe(
      (rsp: ClientNote)=>{
        if(rsp){
          rsp.creatingUserName = `${this.auth.loggedInUser.firstName} ${this.auth.loggedInUser.lastName}`;
          parentCollection.push(rsp);
          parentCollection.sort((a : ClientNote, b : ClientNote) => {
            return a.id - b.id;
          })
          parentCollection.reverse();
          this.toast.success('Note saved successfully.','');
        }else{
          this.toast.warning('Note save failed.','Update Failed!', { disableTimeOut: true, closeButton: true});
        }
      },
      ()=>{
        this.toast.warning('note save failed.','Update Failed!', { disableTimeOut: true, closeButton: true});
      },
    );
  }

  GetNotes(id : number, isLoc : boolean = false) {
    let urlPath : string = isLoc ? `/api/notes/loc/${id}` : `/api/notes/${id}`
    this.http.get(environment.baseURl + urlPath).subscribe((res : ClientNote[]) => {
      this.notes = res;
    },
    err => {
      console.error(err);
      this.toast.error('Error fetching notes!','', { disableTimeOut: true, closeButton: true })
    })
  }

  logData: any[];
  GetLogs() {
    this.http.get(environment.baseURl + '/api/values/emaillogs').subscribe((res: any[]) =>
    {
      this.logData = res;
    },
    err => {
      console.log('ERROR FETCHIN LOGS: ', err)
    },
    () => {}
    );
  }
  
}
